import { useState } from 'react';
import { toast } from 'sonner';
import { supabase } from '@/integrations/supabase/client';

export function useEbookClaim() {
  const [claiming, setClaiming] = useState(false);

  const claimFreeEbook = async (ebookId: string, userId: string): Promise<boolean> => {
    setClaiming(true);
    try {
      const { error } = await (supabase as any)
        .from('user_ebook_claims')
        .insert({ user_id: userId, ebook_id: ebookId, source: 'free_claim' });
      if (error) {
        if (error.code === '23505') return true;
        toast.error('ไม่สามารถรับ ebook ได้ ลองอีกครั้ง');
        return false;
      }
      toast.success('รับ ebook สำเร็จ');
      return true;
    } catch {
      toast.error('ไม่สามารถรับ ebook ได้ ลองอีกครั้ง');
      return false;
    } finally {
      setClaiming(false);
    }
  };

  return { claiming, claimFreeEbook };
}
